import { baseURL } from "../../utils/misc";


 export const getInvitationByCode = async (uniqueCode) => {
  const requestOptions = {
    method: "GET",
    // headers: {
    //   Authorization: `Bearer ${token}`,
    // },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/invitations/code/${uniqueCode}`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching Invitation by code!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};
